<template>
  <div class="w3-border w3-padding-small w3-responsive w3-card w3-margin-top w3-hover-shadow" v-bind:class="{'w3-hide': isHidden}">
    <h5>{{testDatum.test_pack_name}} 
      <button class="w3-button w3-right w3-teal w3-hover-red" v-if="isPrivilegedUser" @click=(deleteTest())>Delete</button> 
      <button class="w3-button w3-right w3-teal" v-if="isPrivilegedUser" @click=(goToEditTest())>Edit</button> 
      <button class="w3-button w3-right w3-teal" @click=(goToPrintTest())>Print</button>
    </h5>
    <h6>{{testDatum.test_date}}</h6>
    <table class="w3-table w3-bordered w3-striped">
      <tbody>
        <tr class="w3-light-blue">
          <th>პარამეტრი</th>
          <th>კოდი</th>
          <th>მნიშვნელობა</th>
          <th>ერთეული</th>
          <th>ნორმა</th>
        </tr>
        <tr v-for="(testRes, pos) in testDatum.test_res" :key="'test-res-'+testDatum.test_id+'-'+pos">
          <td>{{testRes.test_name}}</td>
          <td>{{testRes.test_code}}</td>
          <td>{{testRes.test_result}}</td>
          <td>{{testRes.unit}}</td>
          <td>{{testRes.test_norm}}</td>
        </tr>
      </tbody>
    </table>
    <!-- <p class="w3-tiny w3-teal">{{testDatum}}</p> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: "TestCard",
  props: ["testDatum"],
  data(){
    return {
      isHidden: false
    }
  },
  computed: {
    ...mapGetters({isPrivilegedUser:"getIsprivilegedUser"})
  },
  methods: {
    ...mapActions({removeTest:'REMOVE_TEST'}),
    goToEditTest(){
      this.$router.push({ name: "editTest", params: { patientId: this.testDatum.test_patient_id, testPackId: this.testDatum.test_pack_id, oldTest: this.testDatum } });
    },
    goToPrintTest(){
      let location = window.location.hostname
      let test_id = this.testDatum.test_id
      let url = "http://" + location + '/php_scripts/print_handler.php?sign=1&print_test_id=' + test_id
      window.open(
        url,
        '_blank' // <- This is what makes it open in a new window.
      );
    },
    deleteTest(){
      this.removeTest(this.testDatum)
        .then(result => {
          if (result > 0){
            this.$emit("test-changed")
            this.isHidden = true
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
};
</script>

<style>
</style>
